const I18N_DOMAIN_CONTAINERS = 'tui-containers';

export default I18N_DOMAIN_CONTAINERS;
